// src/Dashboard.js
import React from 'react';

const Resumo = () => {
  const orders = [
    {
      product: "JOGO GOD OF WAR RAGNAROK - PS5",
      sku: "P4021",
      quantity: 100,
      price: 265.00,
      channel: "Americanas Marketplace",
      total: 71.45
    },
    {
      product: "JOGO GOD OF WAR RAGNAROK - PS4",
      sku: "P4021",
      quantity: 100,
      price: 225.00,
      channel: "Mercado Livre",
      total: 57.90
    },
    {
      product: "Jogo Captain Tsubasa Rise of New Champions - PS4",
      sku: "SHP4-2093",
      quantity: 1,
      price: 77.67,
      channel: "Mercado Livre",
      total: 57.90
    },
    {
      product: "Jogo Just Dance 2021 - PS4",
      sku: "SHP4-2122",
      quantity: 1,
      price: 77.90,
      channel: "Americanas Marketplace",
      total: 71.45
    }
  ];

  return (
    <div className="container mt-5">
      <h1 className="mb-4">A Dia na Operação de E-Commerce</h1>
      <div className="row">
        {orders.map((order, index) => (
          <div className="col-md-6 mb-4" key={index}>
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">{order.product}</h5>
                <p className="card-text">SKU: {order.sku}</p>
                <p className="card-text">Quantidade: {order.quantity}</p>
                <p className="card-text">Preço: R$ {order.price.toFixed(2)}</p>
                <p className="card-text">Canal: {order.channel}</p>
                <p className="card-text">Total: R$ {order.total.toFixed(2)}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Resumo;
